
import React, { FC } from 'react';
import { COLORS } from '../../config/designSystem/Colors';
import {  ParagraphMRegular } from '../../config/designSystem/typography';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

export interface TouchableProps extends TouchableOpacityProps {
  onPress: () => void;
  label: string;
}

export const TouchableText: FC<TouchableProps> = ({ onPress, label, ...otherProps  }) => {
  const hitSlop = {
    top: 4,
    bottom: 4,
    left: 4,
    right: 4,
  };
  return (
    <TouchableOpacity hitSlop={hitSlop} {...otherProps} onPress={onPress}>
      <ParagraphMRegular  color={COLORS.content.accent} align={true}>
        {label}
      </ParagraphMRegular>
    </TouchableOpacity>
  );
};